export default __webpack_public_path__ + "static/Keratin-4dc0ed00b9fe56af239ad4ad9bcc7b08.png";